export default {"src":"/_next/static/media/layer-group-solid.0568e6b0.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};